// Angular
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

// Models
import { AppCleanup } from '../../models';

@Component({
	selector: 'scroll-to-top',
	templateUrl: './scroll-to-top.component.html',
	styleUrl: './scroll-to-top.component.scss',
})
export class ScrollToTopComponent extends AppCleanup implements OnInit, OnDestroy, OnChanges {
	@Input() yOffset: number;
	@Input() elementClass: string;
	@Output() onClick: EventEmitter<any> = new EventEmitter();

	showButton: boolean = false;
	scrollTrigger: number = 200;

	constructor() {
		super();
	}

	ngOnChanges() {
		this.showButton = this.yOffset > this.scrollTrigger;
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	scrollToTop() {
		if (this.elementClass) {
			document.getElementsByClassName(this.elementClass)[0].scrollTo({ top: 0, behavior: 'smooth' });
		}
		// window.scrollTo({ top: 0, behavior: 'smooth' });
		// this.onClick.emit();
	}
}
